export const HAD_BABY = '02'
export const ADOPTED_OR_BEGAN_FOSTERING_CHILD = '05'
export const OTHER_QUALIFYING_LIFE_EVENT = 'OTHER'
export const NONE_OF_THE_ABOVE = 'NONE'
